import React, { Component } from "react";

class TextField extends Component {
  render() {
    const {
      container,
      label,
      id,
      name,
      value,
      required,
      handleChange,
      hasError,
      disabled
    } = this.props;
    let labelClass = "font-bold p-3";
    if (required) labelClass += " input-required";
    return (
      <div className={container}>
        <div className="flex flex-wrap items-stretch items-center w-full mb-4 relative">
          <div className="flex -mr-px">
            <button
              type="button"
              className="flex items-center leading-normal bg-grey-lighter rounded rounded-r-none border border-r-0 border-grey-light px-4 whitespace-no-wrap text-grey-dark font-semibold"
              onClick={() => handleChange({ target: {id: id, value: value-1 }})}
              disabled={disabled}
            >
              {" "}
              -{" "}
            </button>
          </div>
          <input
            className="flex w-16 leading-normal border border-grey-light py-3 px-4 relative"
            id={id}
            name={name}
            type="number"
            placeholder={"0"}
            value={value}
            required={required}
            onChange={handleChange}
            disabled={disabled}
          />
          <div className="flex -mr-px">
            <button
              type="button"
              className="flex items-center leading-normal bg-grey-lighter rounded rounded-l-none border border-l-0 border-grey-light px-4 whitespace-no-wrap text-grey-dark font-semibold"
              onClick={() => handleChange({ target: {id: id, value: value+1 }})}
              disabled={disabled}
            >
              {" "}
              +{" "}
            </button>
          </div>
          <div className="flex flex-2 items-center">
            <label className={labelClass} htmlFor={id}>
              {label}
            </label>
          </div>
        </div>

        {hasError && <p className="text-danger text-xs italic">{hasError}</p>}
      </div>
    );
  }
}

export default TextField;
